/*!
 * Built by Revolist
 */
import { R as RevogrFocus, d as defineCustomElement$1 } from './revogr-temp-range2.js';

const RevogrTempRange = RevogrFocus;
const defineCustomElement = defineCustomElement$1;

export { RevogrTempRange, defineCustomElement };
